<template>
  <div class="msgbl-booking">

    <span v-if="booking.interaction_details || booking.interaction_type == 'conference_bridge'">
      <a v-if="whereType === 'map'" :href="googleMapUrl" target="_system">{{booking.where_h}}</a> 
      <a v-else-if="whereType === 'call'" :href='callUrl'> {{booking.where_h}}</a>
      <span v-else-if="whereType === 'conference'">
        <div >{{booking.where_h}}</div>
        <a :href="conferencePhonesUrl" target="_blank">{{$t('appointment.interact.conference_bridge.local_number')}}</a>
      </span>
      <a v-else-if="whereType ==='zoom'" :href="booking.zoom_start_url" target="_system">{{$t('appointment.interact.zoom.link')}}</a>
      <a v-else-if="whereType === 'external'" :href="booking.interaction_details">{{booking.interaction_details}}</a>
      <span v-else-if="whereType ==='online'"> {{booking.interaction_details}}</span>
      <span v-else-if="whereType ==='skype'" >{{booking.where_h}}</span>
      <span v-else>{{booking.where_h}}</span>
    </span>

    <span v-if="!(booking.interaction_details || booking.interaction_type == 'conference_bridge')">
      {{$t('booking.info.interaction_details_missing')}}
    </span>
  </div>
</template>

<script>
import {stringUtil, oldDashboardUtil} from '@/modules/common/utils'

export default {
  name: 'MsgblBooking',
  props: {
    booking: {
      type: Object,
      required: true
    }
  },
  computed: {
    interaction_type() {
      return this.booking.interaction_type
    },
    interaction_details() {
      return this.booking.interaction_details
    },
    whereType() {
      if (this.interaction_type === 'business_location' || 
          this.interaction_type === 'client_location' || 
          this.interaction_type === 'default_business_location') return 'map'
      else if (this.interaction_type === 'business_phone' || this.interaction_type === 'client_phone') return 'call'
      else if (this.interaction_type === 'skype') return 'skype'
      else if (this.interaction_type === 'zoom') return 'zoom'
      else if (this.booking.type !== 'event_instance')
        if (this.booking.state_summary.state === 'scheduled' && this.interaction_type === 'conference_bridge') return 'conference'
        else if (this.interaction_type === 'video_room' || 
                (this.interaction_type === 'online' && stringUtil.validUrl(this.interaction_details)))
          return 'external'
        else if (this.interaction_type === 'online' && !stringUtil.validUrl(this.interaction_details))
          return 'online'
      else if (this.booking.type === 'event_instance' && this.interaction_type === 'online' && stringUtil.validUrl(this.interaction_details))
        return 'external'
      else if (this.interaction_type === 'online' && !stringUtil.validUrl(this.interaction_details))
        return 'online'
      else
        return 'plain'
    },
    googleMapUrl() {
      const query = encodeURIComponent(this.interaction_details)
      return "https://maps.google.com/?q=" + query
    },
    callUrl() {
      return "tel:" + this.interaction_details
    },
    conferencePhonesUrl() {
      return oldDashboardUtil.getUrl('/conferences/numbers')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';

.msgbl-booking {
  display: inline-block;
}
</style>